export interface AccommodationStaySegment {
  date: string;
  poiId: string;
  index: number;
  count: number;
  isStart: boolean;
  isEnd: boolean;
}

/** Derive visual stay ranges without introducing a second persistence model. */
export function deriveAccommodationStaySegments(
  dates: string[],
  sleep: Record<string, string>,
): Map<string, AccommodationStaySegment> {
  const result = new Map<string, AccommodationStaySegment>();
  let cursor = 0;
  while (cursor < dates.length) {
    const date = dates[cursor]!;
    const poiId = sleep[date];
    if (!poiId) {
      cursor += 1;
      continue;
    }
    let end = cursor + 1;
    while (end < dates.length && sleep[dates[end]!] === poiId) end += 1;
    const count = end - cursor;
    for (let index = 0; index < count; index += 1) {
      const segmentDate = dates[cursor + index]!;
      result.set(segmentDate, {
        date: segmentDate,
        poiId,
        index,
        count,
        isStart: index === 0,
        isEnd: index === count - 1,
      });
    }
    cursor = end;
  }
  return result;
}
